import { createScript } from 'lib/dom-helpers';
import Track, { OnePayEventNames } from 'modules/tracking';

const razorpayCheckoutURL = 'https://checkout.razorpay.com/v1/checkout.js';

export interface RazorpayWrapper {
  initialize: (options: object) => Promise<void>;
  addEventListener: (eventName: string, callback: (resp) => void) => void;
}

let Razorpay: RazorpayWrapper | undefined = undefined;

export class RazorpayCheckout implements RazorpayWrapper {
  lib: Promise<void>;
  currentWindow: any;
  razorpayInstance: any;

  constructor(url = '', currentWindow = window) {
    this.lib = createScript(url);

    this.currentWindow = currentWindow;
  }

  initialize = (options) =>
    this.lib.then(
      () =>
        new Promise<void>((resolve, reject) => {
          try {
            this.razorpayInstance = new this.currentWindow.Razorpay(options);
            this.razorpayInstance.open();
            return resolve();
          } catch (error) {
            Track(OnePayEventNames.razorPayFailed, { error });
            return reject(error);
          }
        }),
    );

  addEventListener = (eventName, callback) => {
    if (typeof this.razorpayInstance?.on === 'function') {
      this.razorpayInstance.on(eventName, callback);
    }
  };
}

export default function loadRazorpay() {
  if (!Razorpay) {
    Razorpay = new RazorpayCheckout(razorpayCheckoutURL);
  }
  return Razorpay;
}
